import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadiatorSchematicCardComponent } from './radiator-schematic-card.component';

@NgModule({
  declarations: [RadiatorSchematicCardComponent],
  imports: [CommonModule],
  exports: [RadiatorSchematicCardComponent],
})
export class RadiatorSchematicCardModule {}
